"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_native_1 = require("react-native");
exports.styles = react_native_1.StyleSheet.create({
    scrollview: {
        width: '100%',
        height: react_native_1.Platform.OS === 'web' ? '100vh' : '100%',
        backgroundColor: '#fff',
    },
});
